(() => {
  const colors = {
    black: '#111111', schwarz: '#111111', white: '#ffffff', weiss: '#ffffff', weiß: '#ffffff',
    navy: '#14213d', marine: '#14213d', royal: '#2455a4', blue: '#2867b2', blau: '#2867b2',
    sky: '#79bfe7', turquoise: '#27aeb5', türkis: '#27aeb5', red: '#c92f39', rot: '#c92f39',
    burgundy: '#6f1d2c', bordeaux: '#6f1d2c', pink: '#e8799b', rosa: '#e8799b',
    orange: '#e56824', yellow: '#e8c62d', gelb: '#e8c62d', green: '#348052', grün: '#348052',
    olive: '#727443', khaki: '#93845e', brown: '#76513a', braun: '#76513a', beige: '#d7c5a5',
    natural: '#e8dfca', sand: '#d5bd98', grey: '#818181', gray: '#818181', grau: '#818181',
    silver: '#b7bbc0', silber: '#b7bbc0', purple: '#704b8f', lila: '#704b8f', violet: '#704b8f',
    anthrazit: '#43464b', charcoal: '#43464b', lime: '#9acb3c', neon: '#d7f229'
  };

  const colorFor = (name) => {
    const normalized = name.toLowerCase().trim();
    const key = Object.keys(colors).find((entry) => normalized === entry || normalized.includes(entry));
    return key ? colors[key] : '#d7d4cf';
  };

  const normalize = (value) => value
    .toLocaleLowerCase('de-DE')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const addFilterSearch = (filter, label) => {
    if (filter.querySelector('.aloe-filter-search')) return;
    const list = filter.querySelector('.facets__list--vertical');
    if (!list) return;
    const items = [...list.querySelectorAll(':scope > .facets__item')];
    if (items.length <= 10 || /(farbe|color|colour)/i.test(label)) return;

    const search = document.createElement('div');
    search.className = 'aloe-filter-search';
    search.innerHTML = `
      <span class="svg-wrapper" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none"><circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" stroke-width="1.6"/><path d="m12.5 12.5 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </span>
      <input type="search" autocomplete="off" aria-label="${label} durchsuchen" placeholder="${label} durchsuchen">
      <span class="aloe-filter-search__empty" hidden>Keine passenden Werte</span>`;
    list.before(search);

    const input = search.querySelector('input');
    const empty = search.querySelector('.aloe-filter-search__empty');
    input.addEventListener('input', () => {
      const term = normalize(input.value);
      let visible = 0;
      items.forEach((item) => {
        const matches = !term || normalize(item.textContent).includes(term);
        item.hidden = !matches;
        if (matches) visible += 1;
      });
      empty.hidden = visible !== 0;
    });
  };

  const improvePriceLabel = (filter, label) => {
    if (!/(preis|price)/i.test(label)) return;
    const maximum = filter.querySelector('.facets__price-maximum');
    if (!maximum || maximum.dataset.aloeReady) return;
    maximum.dataset.aloeReady = 'true';
    maximum.textContent = maximum.textContent
      .replace(/^Der höchste Preis ist\s*/i, 'Maximal ')
      .replace(/(?:€\s*){2,}$/u, '€');
  };

  const enhance = (root = document) => {
    root.querySelectorAll('.js-filter').forEach((filter) => {
      const heading = filter.querySelector(':scope > summary');
      if (!heading) return;
      const label = heading.querySelector('.facets__summary-label')?.textContent?.replace(/\(\d+\)/, '').trim() || heading.textContent.trim();
      filter.dataset.aloeFilter = normalize(label).replace(/\s+/g, '-');
      addFilterSearch(filter, label);
      improvePriceLabel(filter, label);

      if (window.matchMedia('(min-width: 990px)').matches && /(preis|farbe|marke|größe|grosse|size)/i.test(label)) {
        filter.open = true;
      }

      if (!/(farbe|color|colour)/i.test(label)) return;

      filter.querySelectorAll('.facet-checkbox').forEach((label) => {
        if (label.querySelector('.aloe-filter-color')) return;
        const text = label.querySelector('.facet-checkbox__text-label')?.textContent || '';
        const swatch = document.createElement('span');
        swatch.className = 'aloe-filter-color';
        swatch.style.setProperty('--aloe-filter-color', colorFor(text));
        const checkboxIcon = label.querySelector(':scope > svg, :scope > .svg-wrapper, :scope > .swatch-input-wrapper');
        if (checkboxIcon) checkboxIcon.after(swatch);
        else label.prepend(swatch);
      });
    });
  };

  enhance();
  new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length)) enhance();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
